const company = {
	/* -------------------------------------------------------------------------- */
	/*                              COMPANY INFO PAGE                             */
	/* -------------------------------------------------------------------------- */
	details: {
		/* ----------------------------- BILLING SECTION ---------------------------- */
		billing: {
			description: "This section contains your billing details.",
			status: {
				success: "Your billing details have been successfully updated!",
			},
			title: "Billing Details",
		},

		/* -------------------------- COMMUNICATION SECTION ------------------------- */
		communication: {
			description: "In this section, you can specify your communication preferences.",
			general: {
				error: "Add at least one email address to the general mailing list.",
				title: "General Mailing List",
			},
			invoice: {
				error: "Add at least one email address to the quotes mailing list.",
				title: "Quotes Mailing List",
			},
			language: {
				tip: "This is the language in which emails, invoices, and quotes will be sent.",
				title: "Communication Language",
			},
			pbs: {
				messages: {
					success: "Email address for PBS error messages successfully updated.",
				},
				placeholder: "For example, errormessages@example.com",
				title: "Email address for PBS error messages",
			},
			status: {
				mailing_list: {
					duplicate: "The email address you entered already exists in this list.",
					success: "Your mailing list has been successfully updated!",
				},
			},
			title: "Communication Preferences",
		},
		/* ----------------------------- COMPANY SECTION ---------------------------- */
		company: {
			description: "This section contains the main contact for this company",
			success: "The main contact for this company has been successfully updated!",
			title: "Main Contact",
		},

		/* ------------------------- CONTACT DETAILS SECTION ------------------------ */
		contact_details: {
			description:
				"Enter the details of the person responsible for the orders and who is the general point of contact for Tuxis.",
			emergency: {
				title: "Emergency Number",
			},
			messages: {
				success: "Details have been successfully changed!",
			},
			title: "General Contact",
		},
		direct_debit: {
			account_holder: {
				label: "Account Holder Name",
				placeholder: "For example John Doe",
			},
			account_number: {
				invalid_iban: "This IBAN number does not appear to be correct",
				label: "Account Number (IBAN)",
				placeholder: "For example NL00 BANK 0012 3456 78",
			},
			bank_location: {
				label: "Bank Location",
				placeholder: "For example Amsterdam",
			},
			bank_name: {
				label: "Bank Name",
				placeholder: "For example ING bank",
			},
			bic_code: {
				label: "BIC Code",
				placeholder: "For example INGBNL2A",
			},
			is_active: {
				checkbox_text: "Enable Direct Debit",
				label: "Direct Debit",
			},
			messages: {
				success: "Direct debit information successfully updated!",
			},
		},
	},
	tabs: {
		company_details: "Company details",
		invoices: "Invoices",
		orders: "Orders",
		user_management: "User management",
	},
	title: "Your Company",
};

export default company;
